export type Initiative = {
  slug: string
  name: string
  category: string
  status: string
  description: string
  cta: string
  href: string
}

export const initiatives: Initiative[] = [
  {
    slug: 'cognocracy',
    name: 'Cognocracy',
    category: 'Civic Governance',
    status: 'Concept Proposal',
    description:
      'A proposed civic governance framework exploring how demonstrated judgment and capability development could inform institutional trust, leadership selection, and public responsibility.',
    cta: 'Explore Cognocracy',
    href: '/projects/cognocracy',
  },
]

export const cognocracyComponents = [
  {
    name: 'SKP',
    classification: 'Knowledge infrastructure',
    body: 'Connects assessment methods, supporting evidence, terminology, and provenance.',
    href: '/semantic-knowledge',
    linkLabel: 'Explore SKP',
  },
  {
    name: 'Human Capability Framework',
    classification: 'Core assessment and development framework',
    body: 'Defines the assessment and development methods used by CJI and NCJI.',
    href: '/human-capability',
    linkLabel: 'Explore the framework',
  },
  {
    name: 'Noetivra',
    classification: 'Visual, interactive workspace',
    body: 'Provides the interactive workspace for reviewing capability profiles, following development pathways, and managing credentials.',
    href: '/noetivra',
    linkLabel: 'Explore Noetivra',
  },
]

export const credentialFields = [
  'Assessed capabilities',
  'Standards met',
  'Assessment date and validity period',
  'Relevant application context',
  'Development priorities',
  'Limitations and uncertainty',
]

export const cognocracyApplications = [
  {
    name: 'Professional Development',
    body: 'Identify strengths and support targeted development.',
  },
  {
    name: 'Leadership Readiness',
    body: 'Inform preparation and evaluation for designated positions of responsibility.',
  },
  {
    name: 'Digital Communities',
    body: 'Enable optional sharing of verified capability credentials.',
  },
  {
    name: 'Civic Governance Research',
    body: 'Examine how demonstrated capability could inform institutional roles and decision-making.',
  },
]

export const cognocracyOpenQuestions = [
  'Assessment validity and real-world usefulness.',
  'Fairness across languages, cultures, disabilities, and socioeconomic circumstances.',
  'Transparent criteria and independent oversight.',
  'Privacy and participant control over disclosure.',
  'Human review and meaningful appeals.',
  'Protection against ideological conformity influencing scores.',
  'Limits on using credentials to determine civic participation or essential access.',
]
